import * as Actions from "../Actions/PagamentoActions";
import _ from 'lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    dialog: null,
    preload: false,
    confirmacaoPagamento: false,
    verificandoPagamento: false,
};

const PagamentoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.PAGAMENTO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                    verificandoPagamento: false,
                    preload: false,
                };
            }
        case Actions.PAGAMENTO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    data: action.data,
                    preload: false,
                };
            }
        case Actions.PAGAMENTO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                    preload: false,
                };
            }
        case Actions.PAGAMENTO_CLEAR:
            {
                return { ...initialState };
            }
        case Actions.CHANGE_PRELOAD:
            {
                return {
                    ...state,
                    preload: !state.preload,
                };
            }
        case Actions.PAGAMENTO_CONFIRMADO:
            {
                return {
                    ...state,
                    preload: false,
                    data: null,
                    confirmacaoPagamento: true,
                    verificandoPagamento: false
                };
            }
        case Actions.VERIFICANDO_PAGAMENTO:
            {
                return {
                    ...state,
                    verificandoPagamento: action.value,
                };
            }
        default:
            {
                return state;
            }
    }
};
export default PagamentoReducer;
